const Store = (() => {
  const state = {
    filename:"",
    "image-edit":{},
    lang: [
      {
        label: "Assamese",
        value: "as",
        name: "Assamese",
        supportWebApi: false,
        keyboardLayout: "assamese",
      },
      {
        label: "Bengali",
        value: "bn",
        name: "বাংলা",
        supportWebApi: false,
        keyboardLayout: "bengali",
      },
      {
        label: "English",
        value: "en",
        name: "English",
        supportWebApi: false,
        keyboardLayout: "english",
      },
      {
        label: "Gujarati",
        value: "gu",
        name: "Gujarati",
        supportWebApi: false,
        keyboardLayout: "gujarati",
      },
      {
        label: "Hindi",
        value: "hi",
        name: "हिन्दी",
        supportWebApi: false,
        keyboardLayout: "hindi",
      },
      {
        label: "Kannada",
        value: "kn",
        name: "ಕನ್ನಡ",
        supportWebApi: false,
        keyboardLayout: "kannada",
      },
      {
        label: "Malayalam",
        value: "ml",
        name: "Malayalam",
        supportWebApi: false,
        keyboardLayout: "malayalam",
      },
      {
        label: "Manipuri",
        value: "mn",
        name: "Manipuri",
        supportWebApi: false,
        keyboardLayout: "manipuri",
      },
      {
        label: "Marathi",
        value: "mr",
        name: "Marathi",
        supportWebApi: false,
        keyboardLayout: "marathi",
      },
      {
        label: "Odia",
        value: "or",
        name: "Odia",
        supportWebApi: false,
        keyboardLayout: "odia",
      },
      {
        label: "Punjabi",
        value: "pa",
        name: "Punjabi",
        supportWebApi: false,
        keyboardLayout: "punjabi",
      },
      {
        label: "Sindhi",
        value: "sd",
        name: "Sindhi",
        supportWebApi: true,
        keyboardLayout: "sindhi",
      },
      {
        label: "Tamil",
        value: "ta",
        name: "தமிழ்",
        supportWebApi: false,
        keyboardLayout: "tamil",
      },
      {
        label: "Telugu",
        value: "te",
        name: "తెలుగు",
        supportWebApi: false,
        keyboardLayout: "telugu",
      },
      {
        label: "Urdu",
        value: "ur",
        name: "اُردُو",
        supportWebApi: false,
        keyboardLayout: "urdu",
      },
    ],
    userData: {
      configs: {
        ner: {
          currentOption: { label: "Retain", value: "retain" },
          id: "ner",
          name: "Named Entities",
          options: [
            { label: "Retain", value: "retain" },
            { label: "Convert", value: "convert" },
          ],
        },
        other: {
          currentOption: { label: "Retain", value: "retain" },
          id: "other",
          name: "Other Entities",
          options: [
            { label: "Retain", value: "retain" },
            { label: "Convert", value: "convert" },
          ],
        },
        salutation: {
          currentOption: { label: "Retain", value: "retain" },
          id: "salutation",
          name: "Salutation",
          options: [
            { label: "Retain", value: "retain" },
            { label: "Convert", value: "convert" },
            { label: "Translate", value: "translate" },
          ],
        },
      },
      firstName: "kaikala",
      language_types: {
        options: [
          { label: "Assamese", value: "as" },
          { label: "Bengali", value: "bn" },
          { label: "English", value: "en" },
          { label: "Gujarati", value: "gu" },
          { label: "Hindi", value: "hi" },
          { label: "Kannada", value: "kn" },
          { label: "Malayalam", value: "ml" },
          { label: "Manipuri", value: "mn" },
          { label: "Marathi", value: "mr" },
          { label: "Odia", value: "or" },
          { label: "Punjabi", value: "pa" },
          { label: "Sindhi", value: "sd" },
          { label: "Tamil", value: "ta" },
          { label: "Telugu", value: "te" },
          { label: "Urdu", value: "ur" },
        ],
      },
      lastName: "harish",
      permission: {
        manage_activity_log: true,
        manage_batch_translation: true,
        manage_corpus_feedback: true,
        manage_doc_editor: true,
        manage_doc_translation: true,
        manage_file_conversion: true,
        manage_glossary: true,
        manage_organisation: true,
        manage_role: true,
        manage_text_translation: true,
        manage_training_corpus: true,
        manage_user: true,
        manage_user_feedback: true,
        permission_name: "Admin",
      },
      userID: 86,
      user_agency: "NCERT",
      user_agency_id: 1,
    },
  };


  const store = { ...state };

  function parse(data) {
    if (Array.isArray(data)) return [...data];
    if (typeof data === "object" && data !== null) return { ...data };
    return data;
  }

  function get(key) {
    return parse(store[key]);
  }

  function update(key, value) {
    if (store.hasOwnProperty(key)) {
      store[key] = parse(value);
     
      return true;
    }
    console.error(`Key "${key}" not found in store.`);
    return false;
  }

  return {
    get,
    update,
  };
})();

export default Store;
